import AuthCallbackPage from '@/features/authentication/pages/AuthCallbackPage';
import ProjectLandingPage from '@/features/project/pages/ProjectLandingPage';
import MixerPage from '@/features/survey-taking/pages/MixerPage';
import TakeSurveyPage from '@/features/survey-taking/pages/TakeSurveyPage';
import { buildMarketingUrl } from '@/utils/subdomainUtils';
import { useEffect } from 'react';
import type { RouteObject } from 'react-router-dom';

/**
 * Redirects to marketing site for unmatched routes
 * Uses window.location.replace for hard redirect (no history entry)
 */
function RedirectToMarketing() {
  useEffect(() => {
    window.location.replace(buildMarketingUrl());
  }, []);

  return null;
}

/**
 * Organization subdomain routes configuration
 * Used for public survey taking (org-slug.hostname.com)
 *
 * Route structure:
 * - /project/:projectId → Project landing page
 * - /survey/:surveyId → Survey landing page
 * - /survey/:surveyId/take → Start/resume taking survey (requires auth if survey.requireLogin)
 * - /mixer/:surveyId → Community mixer voting page
 * - /* → Redirect to marketing site (https://mindmixer.com)
 *
 * Backend validates organization existence via OrganizationContextGuard.
 */
export const subdomainRoutes: RouteObject[] = [
  // OAuth callback route - handles Cognito authentication callback
  {
    path: '/auth/callback',
    element: <AuthCallbackPage />,
  },

  // Project landing page
  {
    path: '/project/:projectId',
    element: <ProjectLandingPage />,
  },

  // Survey landing page
  {
    path: '/survey/:surveyId',
    element: <TakeSurveyPage />,
  },

  // Take survey route (automatically starts survey, requires auth)
  {
    path: '/survey/:surveyId/take',
    element: <TakeSurveyPage skipLandingPage />,
  },

  // Community mixer page
  {
    path: '/mixer/:surveyId',
    element: <MixerPage />,
  },

  // Catch-all - redirect to marketing site
  {
    path: '*',
    element: <RedirectToMarketing />,
  },
];
